import { render, staticRenderFns } from "./quotes-block.vue?vue&type=template&id=b480763a&scoped=true"
var script = {}
import style0 from "./quotes-block.vue?vue&type=style&index=0&id=b480763a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b480763a",
  null
  
)

export default component.exports